import * as firebase from 'firebase';

const config = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID
};

firebase.initializeApp(config);

const database = firebase.database();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

export { firebase, googleAuthProvider, database as default };

// database.ref().set({
//   name: 'MizuBizu TsuNami',
//   age: 7,
//   food: {
//     wet: 'Tiki Cat',
//     dry: 'Orijen'
//   },
//   job: 'Chief Mousers'
// }).then(() => {
//   console.log('Data was saved');
// }).catch((e) => {
//   console.log('Fail', e)
// });

// // database.ref('food/wet').set('Halo');
// database.ref('grooming/shampoo').set('Earthbath');
// database.ref('grooming/ear_cleaner').set('Vetericyn');

// // database.ref('age').set('30').then(() => {
// //   setTimeout(() => {
// //     database.ref('age').remove().then(() => {
// //       console.log('Age was removed');
// //     }).catch((e) => {
// //       console.log('Fail', e);
// //     });
// //   }, 2000);
// // });

// database.ref().update({
//   age: 30,
//   job: null,
//   'grooming/shampoo': 'Earthbath Mango Tango'
// });

// database.ref()
//   .once('value')
//   .then((snapshot) => {
//     const val = snapshot.val();
//     // console.log(val);
//     console.log(`${val.name} eats ${val.food.wet} and ${val.food.dry}.`);
//   })
//   .catch((e) => {
//     console.log(e);
//   });

// database.ref('grooming')
//   .once('value')
//   .then((snapshot) => {
//     const val = snapshot.val();
//     console.log(val);
//   })
//   .catch((e) => {
//     console.log(e);
//   });

// const onValueChange = database.ref('grooming').on('value', (snapshot) => {
//   console.log(snapshot.val());
// }, (e) => {
//   console.log('Error fetching data', e);
// });

// database.ref().off(onValueChange);

// database.ref('notes').push({
//   title: 'Sherlock',
//   description: 'On BBC'
// });

// database.ref('notes').once('value', (snapshot) => {
//   console.log(snapshot.val());
// });

// database.ref('expenses').push({
//   description: 'Rent',
//   note: 'Airbnb',
//   amount: 20000,
//   createdAt: 23435564
// });

// database.ref('expenses').push({
//   description: 'Internet',
//   note: 'Converge',
//   amount: 4000,
//   createdAt: 45364693
// });

// database.ref('expenses').push({
//   description: 'Shopping',
//   note: 'Uniqlo',
//   amount: 8000,
//   createdAt: 34465768
// });

// database.ref('expenses').once('value', (snapshot) => {
//   const expenses = [];

//   snapshot.forEach((childSnapshot) => {
//     expenses.push({
//       id: childSnapshot.key,
//       ...childSnapshot.val()
//     });
//   });

//   console.log(expenses);
// });

// database.ref('expenses/').on('value', (snapshot) => {
//   const expenses = [];

//   snapshot.forEach((childSnapshot) => {
//     expenses.push({
//       id: childSnapshot.key,
//       ...childSnapshot.val()
//     });
//   });

//   console.log(expenses);
// });




// WEBPACK FOOTER //
// ./src/firebase/firebase.js